import { forwardRef, HTMLAttributes } from 'react'

import { useTheme } from '@/contexts/theme'

import { cn } from '@/lib/utils'

export type ContainerProps = HTMLAttributes<HTMLDivElement> & {
  fluid?: boolean
}

const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ className, fluid, ...props }, ref) => {
    const { fluid: fluidTheme } = useTheme()

    return (
      <div
        ref={ref}
        className={cn(
          'container',
          { 'max-w-full': fluidTheme || fluid },
          className
        )}
        {...props}
      />
    )
  }
)

export default Container
